import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaSignInAlt } from 'react-icons/fa';
import { login } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { updateUser } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            setError('');

            const result = await login(email, password);

            if (result.success) {
                updateUser(result);
                navigate('/');
            } else {
                setError(result.message || 'Giriş başarısız');
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            {/* Header Section */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <h1 className="section-title">Giriş Yap</h1>
                        <p className="lead">Hesabınıza giriş yapın ve başvurularınızı takip edin</p>
                    </div>
                </Container>
            </section>

            {/* Login Form Section */}
            <section className="py-5 bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} md={6} lg={5}>
                            <div className="modern-faq-item">
                                <div className="text-center mb-4">
                                    <div className="advantage-icon-modern mb-3">
                                        <FaUser />
                                    </div>
                                    <h3 className="modern-faq-question">Hoş Geldiniz</h3>
                                </div>

                                {error && (
                                    <Alert variant="danger" className="mb-4">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>
                                            <FaUser className="me-2" />
                                            Email
                                        </Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Email adresinizi girin"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className="py-3"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="password">
                                        <Form.Label>
                                            <FaLock className="me-2" />
                                            Şifre
                                        </Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Şifrenizi girin"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            className="py-3"
                                        />
                                    </Form.Group>

                                    <Button
                                        type="submit"
                                        className="apply-btn-black w-100 py-3 mb-4"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Giriş yapılıyor...
                                            </>
                                        ) : (
                                            <>
                                                <FaSignInAlt className="me-2" />
                                                Giriş Yap
                                            </>
                                        )}
                                    </Button>

                                    <div className="text-center mb-3">
                                        <Link
                                            to="/forgot-password"
                                            className="text-decoration-none"
                                            style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}
                                        >
                                            Şifremi unuttum
                                        </Link>
                                    </div>

                                    <div className="text-center">
                                        <p className="mb-0">
                                            Hesabınız yok mu?
                                            <Link to="/register" className="ms-2 fw-bold" style={{ color: 'var(--black)', textDecoration: 'none' }}>
                                                Kayıt Ol
                                            </Link>
                                        </p>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default LoginPage;